let landings

switch (process.env.REACT_APP_MODULE) {
  case 'charisma':
    landings = {
      charisma: 'charisma',
    }
    break

  default:
    landings = {
      default: 'default',
      quiz: 'quiz',
      masculinity: 'masculinity',
      quizMasculinity: 'quiz-masculinity',
      web: 'web',
      dash: 'dash',
      accent: 'accent',
      archetype: 'archetype',
      fellowers: 'fellowers',
      eppc: 'eppc',
      adhd: 'adhd',
      smalltalk: 'smalltalk',
      dating: 'dating',
      interview: 'interview',
      voiceage : 'voiceage',
      laborday : 'laborday',
    }
    break
}

export const LandingEnum = Object.freeze(landings)
